<template lang="html">
  <div class="item__background">
    <div class="item__background__image" :style="{ backgroundImage: 'url(' + project.thumbnail + ')', transform: scale }"></div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  props: {
    project: {
      type: Object
    },
    tempCurrentIndex: {
      type: Number
    }
  },
  data () {
    return {
      scaleValue: null
    }
  },
  computed: {
    ...mapGetters([
      'currentIndex',
      'timer',
      'timerMax'
    ]),
    scale () {
      if (this.currentIndex === this.project.key) {
        this.scaleValue = 1 + (this.timer / this.timerMax) / 6
        return 'scale(' + this.scaleValue + ')'
      } else if (this.tempCurrentIndex === this.project.key) {
        // Keep old scaleValue during slideOut
        return 'scale(' + this.scaleValue + ')'
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../vars";

.item__background {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: -1;
  overflow: hidden;

  &__image {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    transform-origin: bottom left;
    filter: grayscale(80%);
  }

  &:after {
    position: absolute;
    z-index: 10;
    content: '';
    width: 100%;
    height: 100%;
    background-color: rgba($dark, .7);
  }
}
</style>



// WEBPACK FOOTER //
// SliderItemBackground.vue?11b6f410